import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import { Spin, message } from 'antd'
import Icon from '../icon'
import './tagSelection.less'

const MAX_LENGTH = 20
let timeoutId = 0
export default function TagListHistory({ onAdd, onDelete, visible, keyword, setKeyword, localKey, localType, value = new Set() }) {
  const [searchData, setSearchData] = useState([])
  const [loading, setLoading] = useState(false)
  const [historyData, setHistoryData] = useState([])
  useEffect(() => {
    actions.fetchHistoryData()
  }, [visible])
  useEffect(() => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      actions.fetchSearchResult(keyword)
    }, 300)
  }, [keyword])
  const actions = {
    async fetchSearchResult(_keyword) {
      setLoading(true)
      if (!_keyword || historyData?.length <= 0) {
        setLoading(false)
        return
      }
      setSearchData(historyData.filter(m => m.toLowerCase().indexOf(_keyword?.toLowerCase()) >= 0) || [])
      setLoading(false)
    },
    async fetchHistoryData() {
      if (localKey === 'styleColors') {
        const result = window.localStorage.getItem('mnEditImageColors')
        setHistoryData(JSON.parse(result) || [])
        return
      }
      if (localKey === 'sampleColors') {
        const result = window.localStorage.getItem('mnEditSampleColorsValue')
        setHistoryData(JSON.parse(result) || [])
        return
      }
      if (localType === 'sample') {
        const result = window.localStorage.getItem('mnEditSampleParams')
        if (result) {
          const convertResult = JSON.parse(result).find(m => m.propertyId === localKey)
          setHistoryData(convertResult?.values || [])
        }
        return
      }
      const result = window.localStorage.getItem('mnEditImageParams')
      if (result) {
        const convertResult = JSON.parse(result).find(m => m.propertyId === localKey)
        setHistoryData(convertResult?.values || [])
      }
    },
    async clearHistoryData() {
      if (localKey === 'styleColors') {
        window.localStorage.removeItem('mnEditImageColors')
        setHistoryData([])
        return
      }
      if (localKey === 'sampleColors') {
        window.localStorage.removeItem('mnEditSampleColorsValue')
        setHistoryData([])
        return
      }
      if (localType === 'sample') {
        const result = window.localStorage.getItem('mnEditSampleParams')
        if (result) {
          const convertResult = JSON.parse(result).filter(m => m.propertyId != localKey)
          window.localStorage.setItem('mnEditSampleParams', convertResult)
          setHistoryData([])
        }
        return
      }
      const result = window.localStorage.getItem('mnEditImageParams')
      if (result) {
        const convertResult = JSON.parse(result).filter(m => m.propertyId != localKey)
        window.localStorage.setItem('mnEditImageParams', convertResult)
        setHistoryData([])
      }
    },
  }
  const events = {
    onKeyDown(e) {
      if (e.keyCode === 13) {
        events.onClickSearchItem(e.target.value)
      }
    },
    onClearItems() {
      actions.clearHistoryData()
    },
    onChange(e) {
      if (e.target.value.length >= MAX_LENGTH) {
        message.error(`单个标签字数不可超过${MAX_LENGTH}字哦～`)
        return
      }
      setLoading(!!e.target.value)
      setKeyword(e.target.value)
    },
    onClickSearchItem(tagName) {
      setKeyword('')
      events.onClickItem(tagName)
    },
    onClickItem(tagName) {
      if (value.has(tagName)) {
        // 执行删除操作
        onDelete?.(tagName)
        return
      }
      // 添加操作
      onAdd?.(tagName)
    }
  }
  const renderer = {
    listMap(m) {
      return <li
        className={classNames({ active: value.has(m) })}
        onClick={() => events.onClickItem(m)}
      >{m}</li>
    },
    searchList() {
      /* if (searchData.length === 0 && !loading) {
        return <li onClick={() => events.onClickSearchItem(keyword)}>新增“{keyword}”标签</li>
      } */
      return searchData.map(renderer.listMap)
    }
  }
  return <>
    {historyData?.length > 0 && !keyword && <div className="mn-tag-list-history">
      {!keyword.length && historyData?.length > 0 && <>
        <div className="mini-header">
          <span className="recently-used">最近使用</span><a className="clear" onClick={() => events.onClearItems()}>清除记录</a>
        </div>
        <ul className="items-local">
          {historyData?.map(renderer.listMap)}
        </ul>
      </>}
    </div>}
    {searchData?.length > 0 && !!keyword && <div className="mn-tag-list-history">
      {!!keyword.length && <Spin spinning={loading} indicator={<Icon type="m-jiazaizhong" spin />}><ul className="items-local">
        {renderer.searchList()}
      </ul>
      </Spin>}
    </div>}
  </>
}
